export default __webpack_public_path__ + "static/media/email-icon.4f821cc8.svg";